__turbopack_context__.v({
  "btnNav": "NavBar-module__8u-qnq__btnNav",
  "hamburger": "NavBar-module__8u-qnq__hamburger",
  "hamburgerBar": "NavBar-module__8u-qnq__hamburgerBar",
  "hamburgerBarBot": "NavBar-module__8u-qnq__hamburgerBarBot",
  "hamburgerBarMid": "NavBar-module__8u-qnq__hamburgerBarMid",
  "hamburgerBarTop": "NavBar-module__8u-qnq__hamburgerBarTop",
  "menuSlideDown": "NavBar-module__8u-qnq__menuSlideDown",
  "mobileMenu": "NavBar-module__8u-qnq__mobileMenu",
  "mobileMenuAccordion": "NavBar-module__8u-qnq__mobileMenuAccordion",
  "mobileMenuBtnGhost": "NavBar-module__8u-qnq__mobileMenuBtnGhost",
  "mobileMenuBtnPrimary": "NavBar-module__8u-qnq__mobileMenuBtnPrimary",
  "mobileMenuCaret": "NavBar-module__8u-qnq__mobileMenuCaret",
  "mobileMenuCaretOpen": "NavBar-module__8u-qnq__mobileMenuCaretOpen",
  "mobileMenuDivider": "NavBar-module__8u-qnq__mobileMenuDivider",
  "mobileMenuLink": "NavBar-module__8u-qnq__mobileMenuLink",
  "mobileMenuSection": "NavBar-module__8u-qnq__mobileMenuSection",
  "mobileMenuSubLink": "NavBar-module__8u-qnq__mobileMenuSubLink",
  "mobileMenuSubLinks": "NavBar-module__8u-qnq__mobileMenuSubLinks",
  "navCaret": "NavBar-module__8u-qnq__navCaret",
  "navDropdown": "NavBar-module__8u-qnq__navDropdown",
  "navDropdownToggle": "NavBar-module__8u-qnq__navDropdownToggle",
  "navDropdownWrap": "NavBar-module__8u-qnq__navDropdownWrap",
  "navLinks": "NavBar-module__8u-qnq__navLinks",
  "navLoadingPlaceholder": "NavBar-module__8u-qnq__navLoadingPlaceholder",
  "navLogin": "NavBar-module__8u-qnq__navLogin",
  "navLogo": "NavBar-module__8u-qnq__navLogo",
  "navLogoImg": "NavBar-module__8u-qnq__navLogoImg",
  "navRight": "NavBar-module__8u-qnq__navRight",
  "novaNav": "NavBar-module__8u-qnq__novaNav",
});
